if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.start = this.querySelector('.js-search-start');
      this.status = this.querySelector('.js-search-status');
      this.timeout = null;
      this.controller = null;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timeout);
        this.controller?.abort();
        this.btnClearText.disabled = !this.input.value;
        this.errorMessageContainer?.classList.add('hidden');
        this.resultsContainer?.classList.add('hidden');
        if (!this.input.value.trim()) { this.showStart(); return; }
        this.start?.classList.add('hidden');
        if (this.resultsContainer) this.timeout = setTimeout(() => this.getSearchResults(this.input.value.trim()), 250);
      });
      this.input.addEventListener('focus', () => {
        if (this.ignoreFocus) return;
        if (!this.input.value.trim()) this.showStart();
        else if (this.resultsContainer?.innerHTML && this.lastTerm === this.input.value.trim()) this.resultsContainer.classList.remove('hidden');
      });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.hide(); this.ignoreFocus = true; this.input.focus(); this.ignoreFocus = false; }
        if (event.key === 'ArrowDown') {
          const link = this.querySelector('.js-search-start:not(.hidden) a, .js-results-container:not(.hidden) a');
          if (link && link.getClientRects().length) { event.preventDefault(); link.focus(); }
        }
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && event.target !== this.input) { event.preventDefault(); this.hide(); this.ignoreFocus = true; this.input.focus(); this.ignoreFocus = false; }
      });
      this.btnClearText?.addEventListener('click', () => {
        this.input.value = '';
        this.btnClearText.disabled = true;
        this.hide();
        this.input.focus();
        this.showStart();
      });
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); this.showStart(); }
      });
      this.addEventListener('focusout', () => {
        setTimeout(() => { if (!this.contains(document.activeElement)) this.hide(); }, 0);
      });
      this.outside = event => { if (!this.contains(event.target)) this.hide(); };
      document.addEventListener('pointerdown', this.outside);
    }
    disconnectedCallback() {
      clearTimeout(this.timeout);
      this.controller?.abort();
      document.removeEventListener('pointerdown', this.outside);
    }
    showStart() {
      this.resultsContainer?.classList.add('hidden');
      this.errorMessageContainer?.classList.add('hidden');
      this.start?.classList.remove('hidden');
    }
    hide() {
      clearTimeout(this.timeout);
      this.controller?.abort();
      this.start?.classList.add('hidden');
      this.resultsContainer?.classList.add('hidden');
      this.errorMessageContainer?.classList.add('hidden');
      this.classList.remove('is-open');
      if (this.status) this.status.textContent = '';
    }
    async getSearchResults(searchTerm) {
      const controller = new AbortController();
      this.controller = controller;
      const params = new URLSearchParams({q: searchTerm, 'resources[type]': 'product,collection,query', 'resources[limit]': '8', section_id: 'predictive-search'});
      try {
        const response = await fetch(Shopify.routes.root + 'search/suggest?' + params.toString(), {signal: controller.signal});
        if (!response.ok) throw new Error('search');
        const markup = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('#shopify-section-predictive-search');
        if (!markup || controller.signal.aborted || this.input.value.trim() !== searchTerm || !this.contains(document.activeElement)) return;
        this.resultsContainer.innerHTML = markup.innerHTML;
        this.lastTerm = searchTerm;
        this.resultsContainer.classList.remove('hidden');
        this.errorMessageContainer.classList.add('hidden');
        this.start?.classList.add('hidden');
        this.classList.add('is-open');
        if (this.status) this.status.textContent = this.resultsContainer.querySelector('[data-search-status]')?.dataset.searchStatus || '';
        document.querySelector('quick-cart-drawer')?.initTriggers();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.errorMessageContainer?.classList.remove('hidden');
        this.start?.classList.remove('hidden');
      }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
}
